import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface QRScannerProps {
  onResult: (result: string) => void;
  onError?: (error: string) => void;
}

export const QRScanner: React.FC<QRScannerProps> = ({ onResult, onError }) => {
  const scannerRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    // Initialize scanner
    scannerRef.current = new Html5Qrcode('qr-reader');

    // Start scanning
    scannerRef.current
      .start(
        { facingMode: 'environment' },
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText: string) => {
          onResult(decodedText);
          if (scannerRef.current) {
            scannerRef.current.stop();
          }
        },
        (errorMessage: string) => {
          if (onError) {
            onError(errorMessage);
          }
        }
      )
      .catch((err: Error) => {
        if (onError) {
          onError(err.message);
        }
      });

    // Cleanup
    return () => {
      if (scannerRef.current) {
        scannerRef.current
          .stop()
          .catch((err: Error) => console.error('Error stopping scanner:', err.message));
      }
    };
  }, [onResult, onError]);

  return (
    <div className="w-full max-w-sm mx-auto">
      <div id="qr-reader" className="w-full aspect-square" />
      <p className="text-sm text-gray-500 text-center mt-2">
        Position the QR code within the frame to scan
      </p>
    </div>
  );
}; 